import { Box } from '@mui/material';
import { useTranslate } from 'react-admin';

import { bulkUploadResultStatuses } from '@sh4res/bo-common/components/B2bEmployeeBulkCreate/components/bulkUploadStatus';

interface BulkUploadStatusBadgeProps {
  status: keyof typeof bulkUploadResultStatuses;
  size?: 'normal' | 'small';
}

export function BulkUploadStatusBadge({ status, size = 'normal' }: BulkUploadStatusBadgeProps) {
  const translate = useTranslate();
  const isSmall = size === 'small';

  return (
    <Box
      sx={{
        borderRadius: '5px',
        padding: '4px 8px',
        fontSize: '12px',
        fontWeight: 'bold',
        color: 'white',
        backgroundColor: bulkUploadResultStatuses[status],
        ...(isSmall
          ? { padding: '2px 6px', fontSize: '11px' }
          : {
              transition: 'background-color 0.4s ease',
              marginRight: '8px !important',
              marginLeft: '8px !important',
            }),
      }}>
      {translate(
        `resources.bo_common.b2b.employees.actions.bulk_create.sections.results.status.${status}`,
      )}
    </Box>
  );
}
